module.exports = __webpack_public_path__ + "img/sch5-intro-mg1.9321effd.png";